/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCircledCheckOutline
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HighLightKeywordModule } from '../directive/highlight-keyword/highlight-keyword.module';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { ProductReviewsPipesModule } from '../pipes/product-reviews-pipes.module';
import { ReviewBadgesComponentModule } from '../review-badges/review-badges.module';
import { ReviewDrawerListComponent } from './review-drawer-list.component';
import { ReviewFeaturesComponentModule } from '../review-features/review-features.module';
import { ReviewHelpfulModule } from '../review-helpful/review-helpful.module';
import { ReviewMediaComponentModule } from '../review-media/review-media.module';
import { ReviewModalComponentModule } from '../review-modal/review-modal.module';
import { ReviewSecondaryRatingContainerModule } from '../review-secondary-rating-container/review-secondary-rating-container.module';
import { ReviewSliderComponentModule } from '../review-slider/review-slider.module';
import { ReviewStarsComponentModule } from '../review-stars/review-stars.module';
import { ReviewTextComponentModule } from '../review-text/review-text.module';
import { SkeletonLoaderModule } from '../directive/skeleton-loader/skeleton-loader.module';

@NgModule({
	imports: [
		CommonModule,
		HighLightKeywordModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule,
		ProductReviewsPipesModule,
		ReviewBadgesComponentModule,
		ReviewFeaturesComponentModule,
		ReviewHelpfulModule,
		ReviewMediaComponentModule,
		ReviewModalComponentModule,
		ReviewSecondaryRatingContainerModule,
		ReviewSliderComponentModule,
		ReviewStarsComponentModule,
		ReviewTextComponentModule,
		SkeletonLoaderModule
	],
	declarations: [ReviewDrawerListComponent],
	exports: [ReviewDrawerListComponent]
})
export class ReviewDrawerListComponentModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCircledCheckOutline]);
	}
}
